// @flow
const safeTrim = (value?: string) => (typeof value === 'string' && value.trim()) || ''

export default safeTrim
